<template>
  <div class="register-container">
    <div class="container">
      <p class="page-subtitle">以下列出所有购买并且已经注册的设备</p>
      
      <!-- 设备列表 -->
      <div class="device-list">
        <div 
          class="device-card" 
          v-for="device in deviceList" 
          :key="device.sn"
        >
          <div class="card-header">
            <van-icon name="printer" class="device-icon" />
            <div class="device-info">
              <h3 class="device-nickname">{{ device.nickName }}</h3>
              <p class="device-erpname">{{ device.erpname }}</p>
            </div>
          </div>
          
          <div class="card-content">
            <div class="device-image">
              <van-image
                width="120"
                height="120"
                :src="device.printerimg"
                fit="contain"
              />
            </div>
            
            <div class="device-details">
              <div class="detail-item">
                <span class="detail-label">产品型号：</span>
                <span class="detail-value">{{ device.model }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">设备SN：</span>
                <span class="detail-value">{{ device.sn }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">注册日期：</span>
                <span class="detail-value">{{ device.updateTime }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">出厂日期：</span>
                <span class="detail-value">{{ formatDate(device.scan_date) }}</span>
              </div>
            </div>
          </div>
          
          <div class="card-footer">
            <van-button 
              type="default" 
              size="small" 
              class="unbind-btn"
              @click="unbindDevice(device.sn)"
            >
              注销此设备
            </van-button>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="deviceList.length === 0" class="empty-state">
        <van-empty description="暂时没有注册的产品" image="search">
          <van-button 
            round 
            type="primary" 
            class="register-btn"
            @click="addNewDev"
          >
            立即注册
          </van-button>
        </van-empty>
      </div>

      <!-- 注册新设备按钮 -->
      <van-button 
        type="primary" 
        size="large" 
        class="btn-add"
        @click="addNewDev"
      >
        注册新设备
      </van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog, Toast } from 'vant'

export default {
  name: 'ProductRegister',
  data() {
    return {
      deviceList: [],
      token: ''
    }
  },
  created() {
    this.token = localStorage['access_token']
    this.getDeviceList()
  },
  mounted() {
    document.title = '产品注册'
  },
  methods: {
    // 获取设备列表
    getDeviceList() {
      let that = this
      let uri = "/v1/device/Myprinters"
      let getUrl = that.global.BASE_RUL_ABC + uri
      
      Vue.axios.get(getUrl, {
        headers: {
          "Authorization": this.token
        }
      })
      .then(function (result) {
        console.log('设备列表:', result.data)
        if (result.data.data && result.data.data.length !== 0) {
          that.deviceList = result.data.data
        } else {
          that.deviceList = []
        }
      })
      .catch(function (error) {
        console.log(error)
        Toast('网络请求错误，请稍后再试！')
      })
    },
    
    // 注册新设备
    addNewDev() {
       this.$router.push({ path:'/register/detail'  })		
    },
    
    // 注销设备
    unbindDevice(sn) {
      Dialog.confirm({
        title: '确认注销',
        message: '确认要注销这个打印机绑定吗？'
      }).then(() => {
        this.doUnbindDevice(sn)
      }).catch(() => {
        // 用户取消
      })
    },
    
    // 执行注销设备
    doUnbindDevice(sn) {
      let that = this
      let uri = "/v1/device/unbindMyprinter"
      let myUrl = this.global.BASE_URL + uri
      
      let formData = new FormData()
      formData.append('sn', sn)
      
      Vue.axios.post(myUrl, formData, {
        headers: {
          "Authorization": this.token,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(function (result) {
        console.log('注销结果:', result.data)
        if (result.data.Status == 0) {
          Toast.success('打印机解绑成功')
          that.getDeviceList() // 重新加载列表
        } else {
          Toast.fail('解绑失败，请重试')
        }
      })
      .catch(function (error) {
        console.log(error)
        Toast.fail('解绑打印机遇到一些问题，请重试。')
      })
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      return dateString.substring(0, 10)
    }
  }
}
</script>

<style scoped>
.register-container {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 80px;
  width: 100%;
  box-sizing: border-box;
}

.container {
  padding: 16px;
  max-width: 100%;
  box-sizing: border-box;
}

.page-subtitle {
  text-align: center;
  font-size: 14px;
  color: #969799;
  margin-bottom: 20px;
  max-width: 100%;
  word-break: break-all;
}

.device-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 80px;
  max-width: 100%;
}

.device-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid #f0f0f0;
  overflow: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f5f5f5;
  background-color: #fafafa;
  max-width: 100%;
  box-sizing: border-box;
}

.device-icon {
  color: #1989fa;
  font-size: 24px;
  margin-right: 12px;
  flex-shrink: 0;
}

.device-info {
  flex: 1;
  text-align: left;
  min-width: 0;
  max-width: 100%;
}

.device-nickname {
  font-size: 16px;
  font-weight: bold;
  color: #323233;
  margin-bottom: 4px;
  word-break: break-all;
  overflow-wrap: break-word;
  max-width: 100%;
}

.device-erpname {
  font-size: 14px;
  color: #969799;
  margin: 0;
  word-break: break-all;
  overflow-wrap: break-word;
  max-width: 100%;
}

.card-content {
  padding: 16px;
  max-width: 100%;
  box-sizing: border-box;
}

.device-image {
  text-align: center;
  margin-bottom: 16px;
  max-width: 100%;
}

.device-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 14px;
  max-width: 100%;
  gap: 8px;
}

.detail-label {
  color: #646566;
  font-weight: 500;
  flex-shrink: 0;
  min-width: 70px;
}

.detail-value {
  color: #323233;
  text-align: right;
  flex: 1;
  word-break: break-all;
  overflow-wrap: break-word;
  min-width: 0;
}

.card-footer {
  padding: 16px;
  border-top: 1px solid #f5f5f5;
  text-align: center;
  max-width: 100%;
  box-sizing: border-box;
}

.unbind-btn {
  border-radius: 16px;
  font-size: 12px;
  color: #ee0a24;
  border-color: #ee0a24;
  max-width: 100%;
}

.empty-state {
  padding: 60px 20px;
  max-width: 100%;
}

.register-btn {
  margin-top: 16px;
  max-width: 100%;
}

.btn-add {
  position: fixed;
  bottom: 20px;
  left: 5%;
  right: 5%;
  width: 90%;
  border-radius: 20px;
  background-color: #323233;
  border-color: #323233;
  max-width: 90%;
  box-sizing: border-box;
}

/* 响应式设计 */
@media (max-width: 360px) {
  .container {
    padding: 12px;
  }
  
  .device-card {
    border-radius: 8px;
  }
  
  .card-header {
    padding: 12px;
  }
  
  .card-content {
    padding: 12px;
  }
  
  .device-image {
    margin-bottom: 12px;
  }
  
  .detail-item {
    font-size: 13px;
  }
  
  .detail-label {
    min-width: 65px;
  }
}

/* 超小屏幕适配 */
@media (max-width: 320px) {
  .container {
    padding: 8px;
  }
  
  .card-header {
    padding: 10px;
  }
  
  .card-content {
    padding: 10px;
  }
  
  .device-icon {
    font-size: 20px;
    margin-right: 8px;
  }
  
  .device-nickname {
    font-size: 14px;
  }
  
  .device-erpname {
    font-size: 12px;
  }
  
  .detail-item {
    font-size: 12px;
  }
  
  .detail-label {
    min-width: 60px;
  }
}

/* 悬停效果（桌面端） */
@media (hover: hover) {
  .device-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }
  
  .unbind-btn:hover {
    background-color: #ffeef0;
  }
}
</style>